<p-dialog
  [visible]="config().visible"
  [modal]="true"
  [closable]="!config().versionInfo.isMandatory && !isDownloading()"
  [dismissableMask]="!config().versionInfo.isMandatory && !isDownloading()"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onDialogHide()"
  styleClass="update-dialog"
  contentStyleClass="h-50 items-center"
>
  <ng-template pTemplate="header" class="self-center">
    <div class="flex flex-col p-3 md:p-3 text-center">
      <i class="pi mb-1"
         [ngClass]="{
           'pi-exclamation-triangle': !isDownloading(),
           'pi-download': isDownloading(),
           'text-red-400': config().versionInfo.isMandatory && !isDownloading(),
           'text-yellow-400': !config().versionInfo.isMandatory && !isDownloading(),
           'text-blue-400': isDownloading()
         }"
         style="font-size: 3.5rem">
      </i>
      <h2 class="text-xl! font-medium! text-slate-800!">
        @if (isDownloading()) {
          Download in corso
        } @else {
          {{ config().versionInfo.isMandatory ? 'Aggiornamento Obbligatorio' : 'Aggiornamento Disponibile' }}
        }
      </h2>
    </div>
  </ng-template>
 
  <div class="py-4 ">
    <!-- Download Progress Section -->
    @if (isDownloading() || downloadState()?.phase === 'complete') {
      <div class="download-progress-section">
        <!-- Progress Bar -->
        <div class="mb-4">
          @if (showIndeterminate()) {
            <p-progressBar mode="indeterminate" [style]="{ height: '8px' }" />
          } @else {
            <p-progressBar
              [value]="downloadProgress()"
              [showValue]="true"
              [style]="{ height: '16px' }"
            />
          }
        </div>
 
        <!-- Status Message -->
        <div class="text-center mb-3">
          <p class="text-base font-medium text-slate-700 mb-1">
            {{ statusMessage() }}
          </p>
         
          <!-- Speed info (shown after download completes) -->
          @if (downloadSpeed()) {
            <div class="flex justify-center gap-4 text-sm text-slate-500">
              <span class="flex items-center gap-1">
                <i class="pi pi-arrow-down text-xs"></i>
                {{ downloadSpeed() }}
              </span>
            </div>
          }
        </div>
 
      
      
      </div>
    } @else {
      <!-- Update Message (when not downloading) -->
      @if (config().versionInfo.isMandatory) {
        <p class="mb-6 leading-relaxed text-center!">
          La tua versione dell'app non è più supportata. <br>
          Per continuare ad accedere a tutte le funzionalità e mantenere la compatibilità con i nostri sistemi, è necessario effettuare l'aggiornamento.
        </p>
      } @else {
        <p class="mb-6 leading-relaxed text-center!">
          C'è un nuovo aggiornamento disponibile. <br>
          Abbiamo corretto alcuni bug e ottimizzato l'app. Vuoi installarlo subito o preferisci farlo più tardi?
        </p>
      }
 
      <!-- Version Info -->
      <div class="text-center text-sm text-slate-500 mb-4">
        <span>Versione {{ config().versionInfo.version }}</span>
      </div>
    }
 
    <!-- Error Message Section -->
    @if (errorMessage()) {
      <div class="my-4 error-section">
        <p-message severity="error" [text]="errorMessage()" />
       
        @if (showRetryButton()) {
          <div class="flex justify-center mt-4 retry-button-container">
            <p-button
              label="Riprova"
              icon="pi pi-refresh"
              severity="warn"
              (onClick)="onRetry()"
            />
          </div>
        }
      </div>
    }
  </div>
 
  <ng-template pTemplate="footer" class="self-center">
    @if (isDownloading()) {
      <!-- Cancel Download Button (only for optional updates) -->
      @if (!config().versionInfo.isMandatory) {
        <div class="flex justify-center w-full">
          <p-button
            label="Annulla Download"
            severity="secondary"
            variant="outlined"
            icon="pi pi-times"
            (onClick)="onCancelDownload()"
            styleClass="p-2 py-4"
          />
        </div>
      }
    } @else if (config().versionInfo.isMandatory) {
      <!-- Mandatory Update Actions -->
      <div class="flex gap-3 dialog-actions self-center w-full">
        <p-button
          label="Chiudi App"
          severity="danger"
          variant="outlined"
          styleClass="text-white!"
          (onClick)="onExitApp()"
          [disabled]="isDownloading()"
          class="w-50"
          styleClass="p-2 py-4 text-red-400"
        />
        <p-button
          label="Aggiorna Ora"
          severity="primary"
          icon="pi pi-download"
          (onClick)="onUpdateNow()"
          [disabled]="isDownloading()"
          class="w-50"
          styleClass="p-2 py-4"
        />
      </div>
    } @else {
      <!-- Optional Update Actions -->
      <div class="flex gap-3 dialog-actions self-center">
        <p-button
          label="Più Tardi"
          severity="secondary"
          variant="outlined"
          (onClick)="onDismiss()"
          [disabled]="isDownloading()"
          class="w-50"
          styleClass="p-2 py-4"
        />
        <p-button
          label="Aggiorna Ora"
          icon="pi pi-download"
          (onClick)="onUpdateNow()"
          [disabled]="isDownloading()"
          class="w-50"
          styleClass="p-2 py-4"
        />
      </div>
    }
  </ng-template>
</p-dialog>
 
 